// extracted by mini-css-extract-plugin
export default {"buttons":"Sign_buttons__8h7i7","clientNotification":"Sign_clientNotification__bA0nr"};